import React from 'react';
import OrganizationClientInvitationFields, {
    FormValue,
} from '../../../../../shared/OrganizationClientInvitations/OrganizationClientInvitationFields';
import { Form } from '../../../../../v2BaseComponents/Form';
import { APITypes } from '../../../../../../primary-record-types';
import { getIntl } from '../../../../../../utils/intl';
import Stack, { ContentStack } from '../../../../../v2BaseComponents/Stack';
import Text from '../../../../../v2BaseComponents/Text';
import ProgressBar from '../../../../../v2BaseComponents/ProgressBar';

const intl = getIntl('focused-invite-form', {
    next: 'Next',
    previous: 'Previous',
    clientIndex: 'Client {index} of {total}',
    sendInvites: 'Send Invites',
});

export type FocusedInviteFormOwnProps = {
    initialValues: FormValue;
    onSubmit: (values: FormValue) => void;
    inviteIndex: number;
    totalInvites: number;
    invitationDefinitions: APITypes.organizationService.ListDefinitionsResponse['invitationDefinitions'];
    onPrevious: () => void;
};

export type FocusedInviteFormProps = FocusedInviteFormOwnProps;

const FocusedInviteForm: React.FC<FocusedInviteFormProps> = (props) => {
    const progress = Math.floor(((props.inviteIndex + 1) / props.totalInvites) * 100);
    const isLast = props.inviteIndex === props.totalInvites - 1;
    return (
        <Form
            fillContainer
            actionContainerSubmit
            initialValues={props.initialValues}
            onSubmit={(values, helpers) => {
                props.onSubmit(values);
                helpers.setSubmitting(false);
            }}
            saveText={intl(isLast ? 'sendInvites' : 'next')}
            saveIcon={isLast ? 'Send' : 'ArrowRight'}
            cancelIcon="ArrowLeft"
            cancelText={intl('previous')}
            onCancel={props.onPrevious}
        >
            {({ values }) => {
                return (
                    <ContentStack>
                        <Stack
                            vertical
                            justify="center"
                            space={4}
                            style={{ alignSelf: 'stretch', marginBottom: 30 }}
                            align="center"
                        >
                            <Text variant="h4" alignText="center">
                                {intl('clientIndex', { index: props.inviteIndex + 1, total: props.totalInvites })}
                            </Text>
                            <ProgressBar progress={progress} style={{ width: 300 }} />
                        </Stack>
                        <OrganizationClientInvitationFields
                            value={values}
                            invitationDefinitions={props.invitationDefinitions}
                        />
                    </ContentStack>
                );
            }}
        </Form>
    );
};

export default React.memo(FocusedInviteForm);
